<template>
	<el-container>
		<!-- <el-header class="greenmenu">
			<span @click="$router.back(-1)" class="backstr">
				<返回</span> 
				<span class="header_h2">选加项包
			</span>
		</el-header> -->
		<el-header>
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="$router.back(-1)" icon="el-icon-arrow-left" type="text"></el-button>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="$router.back(-1)" :src='"/img/webimg/back.png"' alt=""> -->
			<span class="header_h2">选加项包 </span>
		</el-header>
		<div class="menulist">
			<ul>
				<li>
					<el-button plain round type="warning" @click="SaveItems()">确定选项</el-button>
					<el-button plain round type="danger" v-if="needPay" @click="toPay()">去支付</el-button>
					<el-button plain round type="primary" v-if="canbook" @click="toSelBookBranch()">现在去预约</el-button>
				</li>
				<li>
					<span class="spantxt">可选加项包</span>
					<span class="spanlabel">已选金额:{{selPriceSum}}</span></li>
				<li>
					<ul>

						<div style="width: 40%;float: left;" v-if='groupaddlist.length>0'>

							<li v-for="gal in groupaddlist">
								<p>
									<el-button style="width: 100%;" plain type="warning" @click="gal_click(gal)">{{gal.GroupAddName}}</el-button>
								</p>
								<!-- <p><span v-if="gal.PayType=='0'">支付：单位统结</span></p>
								<p><span v-if="gal.PayType=='1'">支付：个人自费</span></p>
								<p><span v-if="gal.PayType=='2'">支付：统结{{gal.ClientPay}}元,超出自费</span></p>
							 -->
							</li>

						</div>
						<div style="width: 60%;float: left;">
							<el-table size='mini' border tooltip-effect="dark" @selection-change="(selections)=>{selgroupadditems_change(selections)}"
							 :data="groupadditemlist">
								<el-table-column type="selection" width="55">
								</el-table-column>
								<el-table-column prop="SaleModuleName" label="项目名称">
								</el-table-column>
								<el-table-column prop="CurPrice" label="价格">
								</el-table-column>
							</el-table>
						</div>


					</ul>
				</li>


				</li>
			</ul>

		</div>

	</el-container>
</template>

<script>
	import groupitem from '../../apifunction/GroupItem.js'
	import groupadd from '../../apifunction/GroupAddItem.js'
	import cusinfo from '../../apifunction/OrderCus.js'
	export default {
		created() {
			this.cusent = JSON.parse(this.$route.query.ent);
			this.ordergroupent = JSON.parse(this.$route.query.grpent);
			this.showgroupadd();
		},
		data() {
			return {
				cusent: null,
				ordergroupent: null,
				selgroupaddent: null,
				groupaddlist: [],
				groupadditemlist: [],
				selgroupadditems: [],
				selPriceSum: 0,
				needPay: false,
				canbook: false
			}
		},
		methods: {
			showgroupadd() {
				groupadd.GetGroupAddByGroup(this.ordergroupent.OrderID, this.ordergroupent.GroupID)
					.then(res => {
						let entga = JSON.parse(JSON.stringify(res.data))
						if (entga.Flag == 'success') {
							if (entga.Data != 'null') {
								this.groupaddlist = JSON.parse(entga.Data)
								if (this.groupaddlist.length < 1)
									this.toSelBookBranch();
									else
									{
										this.gal_click(this.groupaddlist[0])
									}
							}
							else
							this.toSelBookBranch();
						}
					});
			},
			selgroupadditems_change(d) {
				this.needPay = false;
				this.canbook = false;
				if (d.length < 1) {
					this.selgroupadditems = [];
					this.selPriceSum = 0;
				} else {
					this.selgroupadditems = [];
					let grpadd = this.groupaddlist.find(f => {
						return f.GroupAddID == d[0].GroupAddID;
					});
					let selsum = 0;
					for (let i = 0; i < d.length; i++) {
						let item = {
							GroupID: this.ordergroupent.GroupID,
							GroupAddID: d[i].GroupAddID,
							SaleModuleID: d[i].SaleModuleID,
							SaleModuleName: d[i].SaleModuleName,
							CusID: this.cusent.id,
							GroupAddName: grpadd.GroupAddName,
							PayType: grpadd.PayType,
							OrgPrice: d[i].OrgPrice,
							Discount: d[i].Discount,
							CurPrice: d[i].CurPrice,
							PayState: 0
						}
						selsum += d[i].CurPrice;
						this.selgroupadditems.push(item)
					}
					this.selPriceSum = parseFloat(selsum).toFixed(2);
				}
			},
			gal_click: function(gal) {
				for(let i=0;i<this.groupaddlist.length;i++)
				{
					this.groupaddlist[i].GroupAddName=this.groupaddlist[i].GroupAddName.replace('【✓】','');
				}
				gal.GroupAddName+='【✓】';
				this.selgroupaddent=gal;
				groupadd.GetGroupAddItemByID(gal.GroupAddID)
					.then(res => {
						let entga = JSON.parse(JSON.stringify(res.data))
						if (entga.Flag == 'success') {
							if (entga.Data != 'null') {
								this.groupadditemlist = JSON.parse(entga.Data);

							} else
								this.groupadditemlist = []
						} else
							this.$message.info(entga.Msg);
					});
			},
			SaveItems: function() {

				if (this.selgroupadditems.length < 1) {
					this.$message.info('请勾选检查项目！');
					return;
				}
				let grpadd = this.groupaddlist.find(f => {
					return f.GroupAddID == this.selgroupadditems[0].GroupAddID;
				});
				if (grpadd.MaxNum > 0 && grpadd.MaxNum < this.selgroupadditems.length) {
					this.$message.info('最多只能选择' + grpadd.MaxNum + '个项目呢！');
					return;
				}
				if (this.ordergroupent.PayType == '1') //个人自费
				{
					groupitem.GetGroupItemDataByGroup(this.ordergroupent.OrderID, this.ordergroupent.GroupID)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								let saveitems = [];
								if (ent.Data != 'null') {
									let grpitems = JSON.parse(ent.Data);

									for (let i = 0; i < grpitems.length; i++) {
										let item = {
											GroupID: this.ordergroupent.GroupID,
											GroupAddID: '',
											SaleModuleID: grpitems[i].SaleModuleID,
											SaleModuleName: grpitems[i].SaleModuleName,
											CusID: this.cusent.id,
											GroupAddName: '',
											PayType: this.ordergroupent.PayType,
											OrgPrice: grpitems[i].OrgPrice,
											Discount: grpitems[i].Discount,
											CurPrice: grpitems[i].CurPrice,
											PayState: 0
										}
										saveitems.push(item);
									}
								}
								for (let i = 0; i < this.selgroupadditems.length; i++) {
									saveitems.push(this.selgroupadditems[i]);
								}
								this.SaveItemsToDB(saveitems);
							} else
								this.$message.info('保存选项失败，请重试！' + ent.Msg);

						});
				} else {
					this.SaveItemsToDB(this.selgroupadditems)
				}


			},
			SaveItemsToDB(items) {
				cusinfo.SaveCusGroupAddItems(items)
					.then(res1 => {
						let ent = JSON.parse(JSON.stringify(res1.data))
						if (ent.Flag == 'success') {
							this.$message.info('选项成功！');
							this.canbook = true;
							//打开支付按钮
							// if (items.length > this.selgroupadditems.length) {
							// 	this.needPay = true;
							// 	this.canbook = false;
							// } else {
							// 	// if(this.ordergroupent.ClientPay=='')
							// 	// this.ordergroupent.ClientPay=0;
							// 	if (parseFloat(this.selgroupaddent.ClientPay) < this.selPriceSum) {
							// 		this.needPay = true;
							// 		this.canbook = false;
							// 	} else
							// 		this.canbook = true;
							// }

						} else
							this.$message.info(ent.Msg);
					});
			},
			toPay: function() {
				var data = {
					path: '/ShowCusPay',
					query: {
						ent: this.cusent.id
					}
				};
				this.$router.push(data)
			},
			toSelBookBranch: function() {
				var data = {
					path: '/SelBookBranch',
					query: {
						ent: JSON.stringify(this.cusent)
					}
				};
				this.$router.push(data)

			},
		}
	}
</script>

<style>
</style>
